/**
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v1
 */
import type { Environment } from './types';

export function getEnvironment(): Environment {
    const origin = (import.meta.env.VITE_MAIN_API_ORIGIN as string | undefined) ?? '';
    if (origin.includes('client.producerdashboard.app')) return 'production';
    if (origin.includes('workers.dev')) return 'dev';
    return 'local';
}

export function getMainApiOrigin(): string {
    return (
        (import.meta.env.VITE_MAIN_API_ORIGIN as string | undefined) ??
        'https://producer-dashboard.cloudflare-j157l.workers.dev'
    );
}
